import { z } from "zod";

import { requiredStringSchema } from "./common";

// Define a basic product schema
export const productSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable().optional(),
  price: z.number().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ProductType = z.infer<typeof productSchema>;

export const productFormSchema = z.object({
  name: requiredStringSchema,
});

export type ProductFormType = z.infer<typeof productFormSchema>;

// Product filter schema for use in search and filtering
export const productFilterSchema = z.object({
  search: z.string().default("").catch(""),
});
export type ProductFilterType = z.infer<typeof productFilterSchema>;

export const productSearchParamsSchema = productFilterSchema.extend({
  id: z.string().uuid().optional().catch(undefined),
});
